import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../images/logo.png';
import slogan from '../images/slogan.png';

const PublicHeader = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="bg-white shadow-sm border-b">
      <div className="container-fluid mx-auto px-4">
        <div className="flex justify-between items-center h-16 relative">
          {/* Logo - Sol */}
          <div className="flex items-center space-x-3 flex-shrink-0">
            <Link to="/floor/1" className="flex items-center space-x-2">
              <img 
                src={logo} 
                alt="Korkmazlar Yurt Logo" 
                className="h-10 w-auto"
              />
              <span className="text-xl font-bold text-gray-900">Korkmazlar Yurt</span>
            </Link>
          </div>

          {/* Slogan - Orta */}
          <div className="absolute left-1/2 transform -translate-x-1/2 flex items-center px-20">
            <img 
              src={slogan} 
              alt="Slogan" 
              className="h-16 w-auto max-w-5xl"
            />
          </div>

          {/* Giriş Butonu - Sağ */}
          <div className="flex items-center flex-shrink-0">
            <Link
              to="/login"
              className="px-4 py-2 bg-primary hover:bg-primary-600 text-white rounded-md text-sm font-medium"
            >
              Giriş Yap
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default PublicHeader;


